export enum SelectMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple'
}
